// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"223":"commons","293":"component---src-pages-index-js","480":"component---src-templates-post-js"}[chunkId] + "-" + {"223":"cdb136331cfaeb7f8012","293":"f8e4f7125b66959981b9","480":"4e2ba392f051ebb84268"}[chunkId] + ".js";
};